import { ReactElement } from 'react';

import { ChakraBox, ChakraFlex, ChakraText } from '@equip.health/ui';

type DetailItemProps = {
  icon: ReactElement;
  id: string;
  text: string;
  whiteSpace?: 'normal' | 'nowrap' | 'pre' | 'pre-line';
};

const PatientDetailItem = ({
  icon,
  id,
  text,
  whiteSpace = 'normal',
}: DetailItemProps) => (
  <ChakraFlex marginBottom="8px">
    <ChakraBox minWidth="20px">{icon}</ChakraBox>
    <ChakraText
      color="neutral.secondary"
      fontSize="12px"
      id={id}
      lineHeight="20px"
      marginLeft="6px"
      whiteSpace={whiteSpace}
    >
      {text}
    </ChakraText>
  </ChakraFlex>
);

export default PatientDetailItem;
